var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-pass"},[_c('auth-tabs',{attrs:{"links":_vm.forgotPassLinks}}),_vm._v(" "),_c('div',{staticClass:"forgot-pass__content-wrapper"},[_c('forgot-pass')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }